import { render, staticRenderFns } from "./ContractRenewalApproval.vue?vue&type=template&id=c97d4422"
import script from "./ContractRenewalApproval.vue?vue&type=script&lang=js"
export * from "./ContractRenewalApproval.vue?vue&type=script&lang=js"
import style0 from "./ContractRenewalApproval.vue?vue&type=style&index=0&id=c97d4422&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports